import {getFilterId} from './destinationHelper';
import {
    getNonStandardDisplayedNumber,
    getRecentDisplayedNumber
} from './analytics';

export function isGoogle(selectionType) {
    return selectionType === 'google';
}

function getSelectionType(poweredByGoogle, filterId) {
    if (poweredByGoogle) {
        return 'google';
    } else if (filterId) {
        return 'filter';
    }
    return 'standard';
}

function getGoogleSelectionPlaceIdObject(selectionType, uuid) {
    return isGoogle(selectionType) ? {googleselectionplaceid: uuid} : {};
}

function getFilterIdObject(filterId) {
    return filterId ? {filterid: filterId} : {};
}

function getResultsUuidObject(resultsUuid) {
    return resultsUuid ? {resultsuuid: resultsUuid} : {};
}

export function buildSelectionEventPayload({
    destination,
    subDestination,
    results,
    userInput,
    analytics: {
        backspaceCounter,
        noSelectionCounter,
        prevSearch,
        resultsUuid,
        selectionDepth
    }
}) {
    const filterId = getFilterId(subDestination);
    const selectionType = getSelectionType(
        destination.poweredByGoogle,
        filterId
    );
    const resultsUuidObject = getResultsUuidObject(resultsUuid);
    const filterIdObject = getFilterIdObject(filterId);
    const googleSelectionPlaceIdObject = getGoogleSelectionPlaceIdObject(
        selectionType,
        destination.uuid
    );

    let recentsDisplayed = 0;
    let nonStandardDisplayed = 0;
    let totalResults = 0;

    if (results) {
        recentsDisplayed = getRecentDisplayedNumber(results);
        nonStandardDisplayed = getNonStandardDisplayedNumber(results);
        if (!isGoogle(selectionType)) {
            totalResults = results.length - recentsDisplayed;
        }
    }

    return {
        userinput: userInput,
        totalbackspaces: backspaceCounter,
        totalnoselections: noSelectionCounter,
        totalresults: totalResults,
        selectiondepth: destination.suggestionDepth || selectionDepth,
        selectiontype: selectionType,
        nonstandarddisplayed: nonStandardDisplayed,
        recentsdisplayed: recentsDisplayed,
        prevsearch: prevSearch,
        geouuid: destination.uuid,
        geotypes: destination.type,
        geoname: destination.term,
        matchtype: destination.matchType,
        ...resultsUuidObject,
        ...filterIdObject,
        ...googleSelectionPlaceIdObject
    };
}
